import InboxMobile from './InboxMobile';

export default InboxMobile;
